import React from 'react';
import styles from './ModalTitleView.module.less';
export default function ModalTitleView(props) {
    var _a = props.title, title = _a === void 0 ? '' : _a, _b = props.subTitle, subTitle = _b === void 0 ? '' : _b, _c = props.className, className = _c === void 0 ? '' : _c;
    return (React.createElement("div", { className: styles['modal-title-wrapper'] + " " + styles[className !== null && className !== void 0 ? className : ''] },
        title,
        React.createElement("span", { className: "sub-title" }, subTitle)));
}
